<div [formGroup]="form" *ngIf="isVisible">
  <file-uploader
    [maxSize]="1024 * 5"
    [allowedTypes]="['png', 'jpg', 'jpeg']"
    (select)="onFileSelect($event)"
    (remove)="onFileRemove()"
    class="d-block mt-3 w-100"
  >
    <input
      #file
      type="file"
      (click)="markAsTouched('screenshot')"
      class="input"
    />
    <ng-template #placeholder>
      <img
        src="assets/images/icons/upload-document.svg"
        alt="upload document icon"
      />
      <div class="text-primary pt-2 text-sm" >
       <span i18n="@@support.screenshot">Screenshot</span>  
       <span *ngIf="screenshot?.errors?.required"> *</span> 
      </div>
    </ng-template>
  </file-uploader>
  <small
    i18n="@@support.required"
    class="text-danger"
    *ngIf="screenshot?.errors?.required && screenshot?.touched"
    >* This field is required.</small
  >
  <form-field
    class="front mb-0 mt-3 textarea"
    label="Ticket Message *"
    i18n-label="@@support.message.required.label"
  >
    <textarea
      required
      formControlName="message"
      placeholder="Enter your ticket message"
      rows="5"
      i18n-placeholder="@@support.message.placeholder"
    ></textarea>
  </form-field>
  <small
    i18n="@@support.required"
    class="text-danger"
    *ngIf="message?.errors?.required && message?.touched"
    >* This field is required.</small
  >
</div>
